module.exports = __webpack_public_path__ + "static/flags/PP-a74458e34bf0537faf2eb698094909cd.gif";